/* Responsibility: Updates the counter showing the number of results from a search. */

import fn from '../../lib/fn.js';
import { thousandSeparated } from '../../lib/formatting.js';
import preconditions from '../../lib/preconditions.js';

const checkPreconditions = preconditions('resultCounter', {
    counters: 'list',
    fieldName: 'string',
    eventHub: 'eventHub',
});

export default function resultCounter(params) {
    checkPreconditions(params);

    const updateCount = function (counters, count) {
        fn.forEach(counters, (counter) => {
            counter.innerHTML = count;
        });
    };

    const update = function (data) {
        if (data[params.fieldName]) {
            updateCount(params.counters, thousandSeparated(data[params.fieldName]));
        } else {
            updateCount(params.counters, 0);
        }
    };

    params.eventHub.subscribe('changed-results', update);
    params.eventHub.subscribe('start-poll', update);
}
